import React from 'react';
import { cn } from '../../lib/utils';
import { Card, CardContent } from './card';
import { themeClasses } from '../../config/themeClasses';

function StatCard({ title, value, icon: Icon, iconToneClassName, className }) {
  return (
    <Card className={cn('transition-shadow duration-200 hover:shadow-elevation-4', className)}>
      <CardContent className="p-4 sm:p-6">
        {Icon ? (
          <div className="mb-4 sm:mb-6 flex items-center justify-between">
            <div className={cn(themeClasses.appKit.statIconTile, iconToneClassName)}>
              <Icon className="h-5 w-5 sm:h-6 sm:w-6" aria-hidden />
            </div>
          </div>
        ) : null}
        <div className="space-y-1 sm:space-y-2">
          <p className="text-xs sm:text-sm font-medium text-text-tertiary">{title}</p>
          <p className="text-2xl sm:text-3xl font-semibold tracking-tight text-text-primary">{value}</p>
        </div>
      </CardContent>
    </Card>
  );
}

export { StatCard };
